import { ICompanyGeolocation } from './../../Types/_Store/CategoryDirectory';
import iconGrid3 from 'icon/win10/grid-3.svg?component'
import iconGrid2 from 'icon/win10/grid-2.svg?component'
import iconMapMarker from 'icon/win10/map-marker.svg?component'
import pascalToCamelCase from 'Services/pascalToCamelCase'
import { getCategoryList } from 'Api/categoryApi'
import { getCompanyDetails, getGeocoding } from 'Api/companyGeocoding'
import { getDirectory, getFavoriteDirectory } from 'Api/categoryDirectoryApi'
import { parseInfoDirectory, parseUsefulInformation } from 'Parsers/categoryInfoParser'
import { parseCategoryBox, parseFavoriteCategoryBox, parseDirectoryService, favoriteCompanyMapper } from 'Parsers/categoryDirectoryParser'
import { cardViewTypes } from 'Enums/interfacePreferenceTypes'
import cloneDeep from 'lodash/cloneDeep'
import { ApiCategoryDirectory } from 'Types'
import CategoryDirectoryState from 'Types/_Store/CategoryDirectory'

interface ICategoryDirectorySlug {
  serviceType: string
  region: string
}

interface ICategoryDirectoryQuery {
  page?: number
  sort?: number
  filter?: number
}

interface ICategoryDirectoryOptions {
  slug?: ICategoryDirectorySlug
  query?: ICategoryDirectoryQuery
}

const state: CategoryDirectoryState = {
  requesting: {
    serviceType: false,
    companies: false,
    hearts: false,
    companiesGeolocation: false,
    companyDetails: false,

  },

  info: {
    id: null,
    group: '',
    title: '',
    description: '',
    icon: null,
    distanceInKm: null,

    breadcrumb: {
      category: '',
      serviceType: '',
    },

    slug: {
      serviceType: '',
      category: '',
      region: '',
    },

    images: {
      mobile: '',
      desktop: '',
    },

    region: {
      id: null,
      city: '',
      state: '',
    }
  },

  selected: {
    filter: 0,
    sort: 0,
    favorite: false,
    authenticated: false,
    categories: [],
    companies: [],
    mode: {
      id: cardViewTypes.list,
      type: 'list',
      name: 'Lista',
      icon: iconGrid3
    }
  },

  modeList: [
    { id: cardViewTypes.list, type: 'list', name: 'Lista', icon: iconGrid3 },
    { id: cardViewTypes.grid, type: 'grid', name: 'Grade', icon: iconGrid2 },
    { id: cardViewTypes.map, type: 'map', name: 'Mapa', icon: iconMapMarker },
  ],

  pagination: {
    current: 1,
    limit: 1,
    pageSize: 20,
  },

  selectedCompanyLimit: 4,

  usefulInformation: '',

  companyList: [],

  companyListGeolocation: [],

  favoriteCompaniesList: [],
  serviceTypeList: [],

  companyDetails: null
}

const getters = {
  hasMoreCompanies: state => state.pagination.current < state.pagination.limit
}

const mutations = {
  category_request(state, type) {
    state.requesting[type] = true
  },

  category_success(state, type) {
    state.requesting[type] = false
  },

  category_failure(state, { type, errorList }) {
    state.requesting[type] = false
    state.errorList = errorList
  },

  set_category_info(state, info) {
    Object.assign(state.info, info)
  },

  set_category_selected(state, selected) {
    Object.assign(state.selected, selected)
  },

  set_category_company_list(state, companyList) {
    state.companyList = companyList
  },

  set_category_favorite_company_list(state, favoriteCompaniesList) {
    state.favoriteCompaniesList = favoriteCompaniesList
  },

  set_category_servicetype_list(state, serviceTypeList) {
    state.serviceTypeList = serviceTypeList
  },

  set_useful_information(state, usefulInformation) {
    state.usefulInformation = usefulInformation
  },

  set_pagination(state, pagination) {
    Object.assign(state.pagination, pagination)
  },

  set_category_company_list_geolocation(state, companyListGeolocation) {
    state.companyListGeolocation = companyListGeolocation
  },

  set_company(state, comapany){
    state.companyDetails = comapany
  }
}

const actions = {
  async getServiceList({ commit }, id) {
    commit('category_request', 'serviceType')

    try {
      const { data } = await getCategoryList(id)

      if (data.length === 0) {
        return data
      }

      const [category] = data

      const serviceTypeList = category.serviceTypes.map(parseDirectoryService)
      commit('set_category_servicetype_list', serviceTypeList)

      commit('category_success', 'serviceType')

      return data
    } catch (err) {
      commit('category_failure', { type: 'serviceType', errorList: [] })

      throw err
    }
  },

  /**
   * @param {import('vuex').ActionContext} context
   */
  async getPreviousList({ dispatch, state }) {
    const { current: currentPage } = state.pagination
    const { pageSize: currentPageSize } = state.pagination

    try {
      const page = 1
      const pageSize = currentPageSize * (Math.max(currentPage - 1, 1))

      const query = { page, pageSize }
      const result = await dispatch('getCategoryInfo', { query })

      return result
    } catch (error) {
      throw error
    }
  },

  getApiOptions({ state }, options: ICategoryDirectoryOptions = {}): ICategoryDirectoryOptions {
    let slug = cloneDeep(state.info.slug)

    let query = {
      page: state.pagination.current,
      sort: state.selected.sort,
    }

    if (options.slug) {
      slug = Object.assign(slug, options.slug)
    }


    if (options.query) {
      query = Object.assign(query, options.query)
    }
    return { query, slug }
  },

  async getCategoryInfo({ commit, dispatch, state }, options: ICategoryDirectoryOptions = {}): Promise<ApiCategoryDirectory> {
    const { selected } = state

    commit('category_request', 'companies')

    try {
      /** @type StoreDirectoryOptions */
      const apiOptions = await dispatch('getApiOptions', options) as StoreDirectoryOptions

      /** @type ApiCategoryDirectory */
      const data = selected.favorite
        ? await dispatch('getFavoriteList', apiOptions)
        : await dispatch('getDefaultList', apiOptions)

      const current = data.companies.page
      const limit = Math.ceil(data.companies.totalCount / data.companies.pageSize)

      commit('set_pagination', { current, limit })
      commit('category_success', 'companies')

      return data
    } catch (err) {
      commit('category_failure', { type: 'companies', errorList: [] })

      throw err
    }
  },

  async getDefaultList({ commit, dispatch, state }, apiOptions: ICategoryDirectoryOptions): Promise<ApiCategoryDirectory> {
    const { slug, query } = apiOptions
    try {
      
      const { data } = await getDirectory(slug, query)
      const info = parseInfoDirectory(data)
      commit('set_category_info', info)

      const currentList = cloneDeep(state.companyList)
      const companyList = data.companies.items.map(parseCategoryBox)

      if (state.pagination.current > data.companies.page) {
        const unshiftList = [...companyList, ...currentList]

        commit('set_category_company_list', unshiftList)
      } else {
        const pushList = [...currentList, ...companyList]

        commit('set_category_company_list', pushList)
      }
      if (state.selected.authenticated) {
        dispatch('getFavoriteHearts')
      }

      return data
    } catch (err) {
      throw err
    }
  },

  async getFavoriteList({ commit, state }, apiOptions: ICategoryDirectoryOptions): Promise<ApiCategoryDirectory> {
    const { slug, query } = apiOptions

    try {
      const { data } = await getFavoriteDirectory(slug, query)


      const info = parseInfoDirectory(data)
      commit('set_category_info', info)
      const currentList = cloneDeep(state.companyList)
      const companyList = data.companies.items.map(parseFavoriteCategoryBox)

      if (state.pagination.current > data.companies.page) {
        const unshiftList = [...companyList, ...currentList]

        commit('set_category_company_list', unshiftList)
      } else {
        const pushList = [...currentList, ...companyList]

        commit('set_category_company_list', pushList)
      }

      return data
    } catch (err) {

      throw err
    }
  },

  async getFavoriteHearts({ commit, dispatch, state }) {
    commit('category_request', 'hearts')

    try {
      const { current: currentPage } = state.pagination
      const { pageSize: currentPageSize } = state.pagination

      const page = 1
      const pageSize = currentPageSize * (Math.max(currentPage - 1, 1))
      const newQuery = { page, pageSize }

      /** @type StoreDirectoryOptions */
      const { slug, query } = await dispatch('getApiOptions', { query: newQuery })
      const { data } = await getFavoriteDirectory(slug, query)
      const favoriteList = data.companies.items || []
      commit('set_category_favorite_company_list', favoriteList)
      const mapFavorite = favoriteCompanyMapper(favoriteList)
      const companyList = state.companyList.map(mapFavorite)
      commit('set_category_company_list', companyList)

      commit('category_success', 'hearts')

      return data
    } catch (err) {
      commit('category_failure', { type: 'hearts', errorList: [] })

      throw err
    }
  },

  async getCompanyGeolocation({commit, dispatch}){
    commit('category_request', 'companiesGeolocation')
    try {
      const { slug } = await dispatch('getApiOptions')
      const { data } = await getGeocoding(slug)

      const companiesGeo = data.companyBoxes || []

      commit('set_category_company_list_geolocation', companiesGeo)

      commit('category_success', 'companiesGeolocation')

      return data
    } catch (error) {
      commit('category_failure', { type: 'companiesGeolocation', errorList: [] })

      throw error

    }

  },

  async getCompanyDetails({commit, dispatch}, id){
    commit('category_request', 'companyDetails')
    try {
      const { data } = await getCompanyDetails(id)

      const company = data

      commit('set_company', data)

      commit('category_success', 'companyDetails')

      return data
    } catch (error) {
      commit('category_failure', { type: 'companyDetails', errorList: [] })

      throw error

    }

  },

  resetCompanyList({ commit }) {
    commit('set_category_company_list', [])

    commit('set_pagination', {
      current: 1,
      limit: 1,
      pageSize: 20,
    })
  },

  updateUsefulInformation({ commit }, data) {
    const usefulInformation = parseUsefulInformation(data)

    commit('set_useful_information', usefulInformation)
  },

  updateCategoryInfo({ commit, dispatch }, { data, isAuth }) {

    const syncData = pascalToCamelCase(data)
    const info = parseInfoDirectory(syncData)
    commit('set_category_info', info)
    dispatch('setCategoryRegionToSessionStorage')
    if (syncData.companies && syncData.companies.items) {
      const companyData = syncData.companies || []

      const current = companyData.page
      const limit = Math.ceil(companyData.totalCount / companyData.pageSize)
      commit('set_pagination', { current, limit })

      if (isAuth) {
        const slug = info.slug

        dispatch('getFavoriteHearts')
      }
    }
  },

  setCategoryRegionToSessionStorage({ state }) {
    if(state.info.slug.region !== '')
      return sessionStorage.setItem('state/city', state.info.slug.region)
  },

  updateCategorySelected({ commit }, newMode) {
    commit('set_category_selected', newMode)
  },

  updateCategoryCompanyList({ commit }, newList) {
    commit('set_category_company_list', newList)
  },

  increaseCompanyLimit({ dispatch, state }) {
    const { current, limit } = state.pagination

    if (current < limit) {
      const query = { page: current + 1 }

      dispatch('getCategoryInfo', { query })
    }
  },
}

export default {
  namespaced: true,

  state,
  getters,
  actions,
  mutations
}